import { render, staticRenderFns } from "./OrgProfileEdit.vue?vue&type=template&id=6a3cb596"
import script from "./OrgProfileEdit.vue?vue&type=script&lang=js"
export * from "./OrgProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports